import { useMemo, useState } from "react";
import { Search, Check } from "lucide-react";

export const OccasionBrowser = ({ catalog, selectedId, onSelect, compact = false }) => {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const filtered = useMemo(() => catalog.occasions.filter((o) =>
    (cat === "all" || o.category === cat) && o.label.toLowerCase().includes(q.trim().toLowerCase())), [catalog, q, cat]);

  return (
    <div data-testid="occasion-browser">
      <div className="flex flex-col gap-4">
        <label className="relative block">
          <span className="sr-only">Search occasions</span>
          <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--plum-muted)]" aria-hidden />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search occasions…" className="field !pl-11" data-testid="occasion-search-input" />
        </label>
        <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-2 pr-10 [mask-image:linear-gradient(to_right,black_85%,transparent)] lg:flex-wrap lg:[mask-image:none]" role="tablist" aria-label="Occasion categories">
          {[{ id: "all", label: "All" }, ...catalog.categories].map((c) => (
            <button key={c.id} role="tab" aria-selected={cat === c.id} onClick={() => setCat(c.id)} data-testid={`occasion-category-${c.id}`}
              className={`shrink-0 rounded-full border px-4 py-2 text-sm transition-colors ${cat === c.id ? "border-[var(--plum)] bg-[var(--plum)] text-[var(--ivory)]" : "border-[var(--parchment)] bg-white hover:border-[var(--gold)]"}`}>
              {c.label}
            </button>
          ))}
        </div>
      </div>
      {filtered.length === 0 ? (
        <div className="card-parch mt-6 p-8 text-center" data-testid="occasion-no-results">
          <p className="font-display text-xl">No occasion matches “{q}”.</p>
          <p className="mt-2 text-sm text-[var(--plum-muted)]">Choose Custom Occasion and describe it in your own words.</p>
          <button className="btn-ghost mt-4" onClick={() => onSelect(catalog.occasions.find((o) => o.id === "custom"))} data-testid="occasion-no-results-custom">Use Custom Occasion</button>
        </div>
      ) : (
        <div className="mt-6 space-y-8">
          {catalog.categories.filter((c) => filtered.some((o) => o.category === c.id)).map((c) => (
            <section key={c.id} aria-labelledby={`cat-${c.id}`}>
              <h3 id={`cat-${c.id}`} className="eyebrow">{c.label}</h3>
              <div className={`mt-3 grid gap-3 ${compact ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"}`}>
                {filtered.filter((o) => o.category === c.id).map((o) => (
                  <button key={o.id} onClick={() => onSelect(o)} aria-pressed={selectedId === o.id} data-testid={`occasion-card-${o.id}`}
                    className={`card-parch flex items-center justify-between px-5 py-4 text-left hover:-translate-y-0.5 hover:border-[var(--gold)] ${selectedId === o.id ? "!border-[var(--gold)] ring-2 ring-[var(--gold)]/30" : ""}`}>
                    <span className="font-medium">{o.label}</span>
                    {selectedId === o.id && <Check className="h-4 w-4 text-[var(--gold-deep)]" aria-hidden />}
                  </button>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};
